import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import ManagerCommentWidget from '../../../widgets/progressReportWidget/ManagerCommentWidget'
import AcknowledgementWidget from '../../../widgets/progressReportWidget/AcknowledgementWidget'
import IntroductionWidget from '../../../widgets/progressReportWidget/IntroductionWidget'
import OperationalProgressWidget from '../../../widgets/progressReportWidget/OperationalProgressWidget'
import ProgessActivityWidget from '../../../widgets/progressReportWidget/ProgessActivityWidget'
import ProgessProductWidget from '../../../widgets/progressReportWidget/ProgessProductWidget'
import ProgessOutcomeWidget from '../../../widgets/progressReportWidget/ProgessOutcomeWidget'
import ProgressIndicatorWidget from '../../../widgets/progressReportWidget/ProgressIndicatorWidget'
import ProgessResultWidget from '../../../widgets/progressReportWidget/ProgessResultWidget'
import PercentOfProgressWidget from '../../../widgets/progressReportWidget/PercentOfProgressWidget'
import ProblemsAndSolutionWidget from '../../../widgets/progressReportWidget/ProblemsAndSolutionWidget'
import RiskAssessmentWidget from '../../../widgets/progressReportWidget/RiskAssessmentWidget'
import SearchTagWidget from '../../../widgets/progressReportWidget/SearchTagWidget'
import TargetGroupAndAreaWidget from '../../../widgets/progressReportWidget/TargetGroupAndAreaWidget'
import WorkSummaryWidget from '../../../widgets/progressReportWidget/WorkSummaryWidget'
import AttachFilesWidget from '../../../widgets/progressReportWidget/AttachFilesWidget'
import ProgressAssetWidget from '../../../widgets/progressReportWidget/ProgressAssetWidget'
import LearningCenterView from '../../../widgets/progressReportWidget/LearningCenterView'
import NetworkAndOrganiationView from '../../../widgets/progressReportWidget/NetworkAndOrganiationView'
import SendFeedbackWidget from '../../../widgets/progressReportWidget/SendFeedbackWidget'
// import DolMultimediaView from '../../../widgets/progressReportWidget/DolMultimediaView'
import DolMultimediaWidget from '../../../widgets/progressReportWidget/DolMultimediaWidget'

import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import {
  getProgressReportForm,
  getProgressProduct,
  downloadProgressFile,
  getDolExternal,
  getIamExternal,
  copyPreviousProgress,
  copyToNextProgress,
} from '../../../redux/actions/projectProgress'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import { Panel, Message, Row, IconButton, Icon } from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import ConfirmWidget from '../../../widgets/confirm/ConfirmWidget'
import pathname from '../../../constants/pathname'
import { SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import notification from '../../../utils/notification'
import CoworkerEvaluateYourselfWidget from '../../../widgets/evaluatesWidgets/coworkerEvaluateYourselfWidgets/CoworkerEvaluateYourselfWidget'

export default function ProgressReport(props) {
  // const [isEditAll, setIsEditAll] = useState(false)
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  const [targetGroupSchema, setTargetGroupSchema] = useState()
  const [showEditAll, setShowEditAll] = useState()
  const [progressId, setProgressId] = useState()
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [projectCode, setProjectCode] = useState('')
  const [dolValues, setDolValues] = useState()
  const [iamValues, setIamValues] = useState()
  const [errorDOL, setErrorDOL] = useState(false)
  const [errorIam, setErrorIam] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [errorGetPrevious, setErrorGetPrevious] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // let progressId = location.search.substring(1)
    let progressId = sessionStorage.getItem('param')?.substring(1)
    // console.log('load ProgressReport project_id: ', projectId, 'progress_id: ', progressId)
    setProgressId(progressId)
    // if (projectId == menuType.projectManagementReview) {
    //   setSchemas(mockSchemaComment)
    // } else {
    handleGetSchema(projectId, progressId)
    //handleGetDownloadProgressFile(projectId, progressId)
    // }
  }, [location.search])

  useEffect(() => {
    if (projectCode) {
      // handleGetDOL(projectCode)
      handleGetIam(projectCode)
    }
  }, [projectCode])

  const addressString = (adr) => {
    let str = ''
    if (adr) {
      if (adr.moo) {
        str += `หมู่ที่ ${adr.moo} `
      }
      if (adr.no) {
        str += `เลขที่ ${adr.no} `
      }
      if (adr.floorNumber) {
        str += `ชั้น ${adr.floorNumber} `
      }
      if (adr.roomName) {
        str += `ห้อง ${adr.roomName} `
      }
      if (adr.villageName) {
        str += `หมู่บ้าน ${adr.villageName} `
      }
      if (adr.soiName) {
        str += `ตรอก/ซอย ${adr.soiName} `
      }
      if (adr.subDistrictInfo.subDistrictName) {
        str += `ตำบล/แขวง ${adr.subDistrictInfo.subDistrictName} `
      }
      if (adr.districtInfo.districtName) {
        str += `อำเภอ/เขต ${adr.districtInfo.districtName} `
      }
      if (adr.provinceInfo.provinceName) {
        str += `อำเภอ/เขต ${adr.provinceInfo.provinceName} `
      }
      if (adr.postCode) {
        str += `รหัสไปรษณีย์ ${adr.postCode} `
      }
    }

    return str
  }

  const targetString = (tar) => {
    let str = ''

    if (tar) {
      if (tar.length === 1) {
        tar.map((target, index) => {
          const { targetName } = target
          str += `1.${targetName}`
        })
      } else {
        tar.map((target, index) => {
          const { targetName } = target
          str += `${index + 1}.${targetName} `
        })
      }
    }

    return str
  }

  const handleGetSchema = async (projectId, progressId) => {
    setIsLoading(true)
    startLoading()
    try {
      // if (projectCode) {
      //   const _schemaDol = await getDolExternal(projectCode, 5, 1)
      //   const _schemaIam = await getIamExternal(projectCode)

      //   if (_schemaIam.code === '200') {
      //     let arrData = []
      //     _schemaIam.resourceCenterInfos.map((res, index) => {
      //       const {
      //         resourceCenterID,
      //         resourceCenterName,
      //         addressInfo,
      //         contactInfos,
      //         resourceCenterTargetInfos,
      //       } = res

      //       let data = {
      //         id: resourceCenterID,
      //         name: resourceCenterName,
      //         address: addressString(addressInfo),
      //         target: targetString(resourceCenterTargetInfos),
      //       }
      //       arrData.push(data)
      //     })

      //     setIamValues(arrData)
      //   }

      //   setDolValues(_schemaDol)
      // }

      const schema = await getProgressReportForm(projectId, progressId)

      setSchemas(schema)

      await setEnableEdit(schema)

      setError()
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const setEnableEdit = async (schema) => {
    setIsEditWidget({
      managerComment:
        schema?.forms?.managerComment?.isInitial && schema?.forms?.managerComment?.enableEdit,
      acknowledgement:
        schema?.forms?.acknowledgement?.isInitial && schema?.forms?.acknowledgement?.enableEdit,
      introduction:
        schema?.forms?.introduction?.isInitial && schema?.forms?.introduction?.enableEdit,
      operationalProgress:
        schema?.forms?.operationalProgress?.isInitial &&
        schema?.forms?.operationalProgress?.enableEdit,
      progessActivity:
        schema?.forms?.progessActivity?.isInitial && schema?.forms?.progessActivity?.enableEdit,
      // progessProduct:
      //   schema?.forms?.progessProduct?.isInitial && schema?.forms?.progessProduct?.enableEdit,
      progressIndicator:
        schema?.forms?.progressIndicator?.isInitial && schema?.forms?.progressIndicator?.enableEdit,
      progessOutcome:
        schema?.forms?.progessOutcome?.isInitial && schema?.forms?.progessOutcome?.enableEdit,
      progessResult:
        schema?.forms?.progessResult?.isInitial && schema?.forms?.progessResult?.enableEdit,
      percentOfProgress:
        schema?.forms?.percentOfProgress?.isInitial && schema?.forms?.percentOfProgress?.enableEdit,
      problemsAndSolution:
        schema?.forms?.problemsAndSolution?.isInitial &&
        schema?.forms?.problemsAndSolution?.enableEdit,
      riskAssessment:
        schema?.forms?.riskAssessment?.isInitial && schema?.forms?.riskAssessment?.enableEdit,
      searchTag: schema?.forms?.searchTag?.isInitial && schema?.forms?.searchTag?.enableEdit,
      targetGroup: schema?.forms?.targetGroup?.isInitial && schema?.forms?.targetGroup?.enableEdit,
      workSummary: schema?.forms?.workSummary?.isInitial && schema?.forms?.workSummary?.enableEdit,
      attachments: schema?.forms?.attachments?.isInitial && schema?.forms?.attachments?.enableEdit,
      progressAsset:
        schema?.forms?.progressAsset?.isInitial && schema?.forms?.progressAsset?.enableEdit,
    })
    setShowEditAll(
      schema.forms?.managerComment?.enableEdit &&
        schema.forms?.acknowledgement?.enableEdit &&
        schema.forms?.introduction?.enableEdit &&
        schema.forms?.operationalProgress?.enableEdit &&
        schema.forms?.progessActivity?.enableEdit &&
        // _schema.forms?.progessProduct?.enableEdit &&
        schema.forms?.progressIndicator?.enableEdit &&
        schema.forms?.progessOutcome?.enableEdit &&
        schema.forms?.progessResult?.enableEdit &&
        schema.forms?.percentOfProgress?.enableEdit &&
        schema.forms?.problemsAndSolution?.enableEdit &&
        schema.forms?.riskAssessment?.enableEdit &&
        schema.forms?.searchTag?.enableEdit &&
        schema.forms?.targetGroup?.enableEdit &&
        schema.forms?.workSummary?.enableEdit &&
        schema.forms?.attachments?.enableEdit &&
        schema.forms?.progressAsset?.enableEdit
    )
  }

  const handleGetDOL = async (projectCode) => {
    //setIsLoading(true)
    startLoading()
    setErrorDOL(false)
    try {
      const _schemaDol = await getDolExternal(projectCode, 5, 1)
      setDolValues(_schemaDol)
    } catch (e) {
      console.log('error', e)
      setErrorDOL(true) // can set error message here (set string)
    }
    doneLoading()
    //setIsLoading(false)
  }

  const handleGetIam = async (projectCode) => {
    //setIsLoading(true)
    startLoading()
    setErrorIam(false)
    try {
      const _schemaIam = await getIamExternal(projectCode)
      if (_schemaIam.code === '200') {
        let arrData = []
        _schemaIam.resourceCenterInfos.map((res, index) => {
          const {
            resourceCenterID,
            resourceCenterName,
            addressInfo,
            contactInfos,
            resourceCenterTargetInfos,
          } = res

          let data = {
            id: resourceCenterID,
            name: resourceCenterName,
            address: addressString(addressInfo),
            target: targetString(resourceCenterTargetInfos),
          }
          arrData.push(data)
        })

        setIamValues(arrData)
      } else {
        setErrorIam(true) // can set error message here (set string)
      }
    } catch (e) {
      console.log('error', e)
      setErrorIam(true) // can set error message here (set string)
    }
    doneLoading()
    //setIsLoading(false)
  }

  const handleUpdateActivity = async () => {
    //setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProgressProduct(projectId, progressId)
      setSchemas((state) => ({
        ...state,
        forms: {
          ...state.forms,
          progessProduct: _schema,
        },
      }))
      setError()
    } catch (e) {
      console.log('error', e)
      // if (e?.response?.data) {
      //   setError({
      //     statusCode: e.response.data.status,
      //     errorMessage: e.response.data.errors?.message,
      //   })
      // } else {
      //   setError({})
      // }
    }
    doneLoading()
    //setIsLoading(false)
  }

  const handleGetDownloadProgressFile = async (projectId, progressId) => {
    startLoading()
    //setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await downloadProgressFile(projectId, progressId)
      // console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      setIsPdfError(true)
    }
    //setIsLoading(false)
    setIsLoadingPDF(false)
    doneLoading()
  }

  const handleGetPreviousProgressReport = async () => {
    startLoading()
    // setIsLoading(true)
    setErrorGetPrevious(false)
    try {
      const response = await copyPreviousProgress(projectId, progressId)
      // setIsLoading(true)
      setSchemas(response)
      await setEnableEdit(response)
    } catch (e) {
      if (e?.response?.data?.errors?.message) {
        setErrorGetPrevious(e?.response?.data?.errors?.message)
      } else {
        setErrorGetPrevious(
          'ตั้งต้นจากรายงานความก้าวหน้าครั้งก่อน ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
        )
      }
    }
    setIsShowConfirm(false)
    // setIsLoading(false)
    doneLoading()
  }

  const handleCallUpdateToClose = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await copyToNextProgress(projectId, progressId)

      if (response) {
        doneLoading()
        setIsLoading(false)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        sessionStorage.setItem('projectId', projectId)
        sessionStorage.setItem('param', `?${response?.nextProgressId}`)
        // window.location.href = `${pathname.proposal.projectManagement.progressReport}/${projectId}?${response?.nextProgressId}`
        window.location.href = `${pathname.proposal.projectManagement.progressReport}`
        window.opener = null
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title:
          e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || SAVE_FAILED_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }
  const handleSetProjectCode = (proCode) => {
    setProjectCode(proCode)
  }

  const gotoWithdraw = (withdrawId) => {
    sessionStorage.setItem('projectId', projectId)
    sessionStorage.setItem('param', `?${withdrawId}`)

    //window.location.href = `${pathname.proposal.projectManagement.withdrawRequest}/${projectId}?${withdrawId}`
    window.location.href = `${pathname.proposal.projectManagement.withdrawRequest}`
    window.opener = null
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader
          header={schemas.header}
          subHeader={schemas.subHeader}
          projectCode={handleSetProjectCode}
        />

        <div style={{ marginBottom: 20 }}>
          {showEditAll && (
            <BtnEditAll
              onClickEditAll={getIsEditAll(isEditWidget)}
              setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
            />
          )}
          <Message
            showIcon
            type="warning"
            style={{ marginBottom: 10 }}
            description="เมื่อรายงานความก้าวหน้าโครงการครบแล้ว กรุณาทำการขอเบิกงวดเงินไปยัง สสส. ด้วย"
          />

          {schemas?.forms?.copyPreviousProgress && (
            <Panel
              header={schemas.forms.copyPreviousProgress.header}
              shaded
              collapsible
              defaultExpanded
              style={{ marginBottom: 30 }}
            >
              <Message
                showIcon
                type="warning"
                description={`*** ในกรณีที่มีการกรอกข้อมูลไปบ้างแล้ว ข้อมูลจะถูกแทนที่ด้วยข้อมูลจากรายงานครั้งก่อนหน้า ***`}
                style={{ marginBottom: 10 }}
              />
              {errorGetPrevious && (
                <Message
                  showIcon
                  type="error"
                  description={errorGetPrevious}
                  style={{ marginBottom: 10 }}
                />
              )}

              <SaveButton icon="copy-o" onClick={() => setIsShowConfirm(true)} disabled={isLoading}>
                {schemas.forms.copyPreviousProgress.buttonText}
              </SaveButton>
            </Panel>
          )}

          {schemas?.forms?.progressSummary && (
            <AgreementAdditionalWidgets
              showCommandButton={true}
              formSchema={schemas.forms.progressSummary}
            />
          )}

          {/* ความก้าวหน้าในการดำเนินงาน */}
          {schemas?.forms?.operationalProgress && (
            <>
              <OperationalProgressWidget
                showCommandButton={
                  schemas.forms.operationalProgress.enableEdit ||
                  schemas.forms.operationalProgress.comment?.enableEdit
                }
                schema={schemas.forms.operationalProgress}
                isEdit={isEditWidget.operationalProgress}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('operationalProgress', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* กิตติกรรมประกาศ */}
          {schemas?.forms?.acknowledgement && (
            <>
              <AcknowledgementWidget
                showCommandButton={
                  schemas.forms.acknowledgement.enableEdit ||
                  schemas.forms.acknowledgement.comment?.enableEdit
                }
                schema={schemas.forms.acknowledgement}
                isEdit={isEditWidget.acknowledgement}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('acknowledgement', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* คำนำ */}
          {schemas?.forms?.introduction && (
            <>
              <IntroductionWidget
                showCommandButton={
                  schemas.forms.introduction.enableEdit ||
                  schemas.forms.introduction.comment?.enableEdit
                }
                schema={schemas.forms.introduction}
                isEdit={isEditWidget.introduction}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('introduction', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* สรุปความเห็นผู้บริหาร */}
          {schemas?.forms?.managerComment && (
            <>
              <ManagerCommentWidget
                showCommandButton={
                  schemas.forms.managerComment.enableEdit ||
                  schemas.forms.managerComment.comment?.enableEdit
                }
                schema={schemas.forms.managerComment}
                isEdit={isEditWidget.managerComment}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('managerComment', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* คำค้น */}
          {schemas?.forms?.searchTag && (
            <>
              <SearchTagWidget
                showCommandButton={
                  schemas.forms.searchTag.enableEdit || schemas.forms.searchTag.comment?.enableEdit
                }
                schema={schemas.forms.searchTag}
                isEdit={isEditWidget.searchTag}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('searchTag', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* กลุ่มเป้าหมายและพื้นที่ในการดำเนินการ */}
          {schemas?.forms?.targetGroup && (
            <>
              <TargetGroupAndAreaWidget
                showCommandButton={
                  schemas.forms.targetGroup.enableEdit ||
                  schemas.forms.targetGroup.comment?.enableEdit
                }
                schema={schemas.forms.targetGroup}
                isEdit={isEditWidget.targetGroup}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('targetGroup', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* สรุปผลงาน */}
          {schemas?.forms?.workSummary && (
            <>
              <WorkSummaryWidget
                showCommandButton={
                  schemas.forms.workSummary.enableEdit ||
                  schemas.forms.workSummary.comment?.enableEdit
                }
                schema={schemas.forms.workSummary}
                isEdit={isEditWidget.workSummary}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('workSummary', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* ผลการดำเนินการ (กิจกรรม) */}
          {schemas?.forms?.progessActivity && (
            <>
              <ProgessActivityWidget
                showCommandButton={
                  schemas.forms.progessActivity.enableEdit ||
                  schemas.forms.progessActivity.comment?.enableEdit
                }
                schema={schemas.forms.progessActivity}
                isEdit={isEditWidget.progessActivity}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('progessActivity', _isEdit, setIsEditWidget)
                }
                onAddActivity={() => handleUpdateActivity()}
              />
              <br />
            </>
          )}

          {/* การประเมินความสำเร็จของโครงการร้อยละ */}
          {schemas?.forms?.percentOfProgress && (
            <>
              <PercentOfProgressWidget
                showCommandButton={
                  schemas.forms.percentOfProgress.enableEdit ||
                  schemas.forms.percentOfProgress.comment?.enableEdit
                }
                schema={schemas.forms.percentOfProgress}
                isEdit={isEditWidget.percentOfProgress}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('percentOfProgress', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* ผลผลิตที่เกิดขึ้นจริง */}
          {/* {schemas?.forms?.progessProduct && (
          <>
            <ProgessProductWidget
              showCommandButton={
                schemas.forms.progessProduct.enableEdit ||
                schemas.forms.progessProduct.comment?.enableEdit
              }
              schema={schemas.forms.progessProduct}
              isEdit={isEditWidget.progessProduct}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('progessProduct', _isEdit, setIsEditWidget)
              }
            />
            <br />
          </>
        )} */}

          {/* ตัวชี้วัด */}
          {schemas?.forms?.progressIndicator && (
            <>
              <ProgressIndicatorWidget
                showCommandButton={
                  schemas.forms.progressIndicator.enableEdit ||
                  schemas.forms.progressIndicator.comment?.enableEdit
                }
                schema={schemas.forms.progressIndicator}
                isEdit={isEditWidget.progressIndicator}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('progressIndicator', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* ผลลัพธ์ */}
          {schemas?.forms?.progessOutcome && (
            <>
              <ProgessOutcomeWidget
                showCommandButton={
                  schemas.forms.progessOutcome.enableEdit ||
                  schemas.forms.progessOutcome.comment?.enableEdit
                }
                schema={schemas.forms.progessOutcome}
                isEdit={isEditWidget.progessOutcome}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('progessOutcome', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* ผลลัพธ์หรือแนวทาง/วิธีการในการขยายผล/ผลที่คาดว่าจะได้รับ */}
          {schemas?.forms?.progessResult && (
            <>
              <ProgessResultWidget
                showCommandButton={
                  schemas.forms.progessResult.enableEdit ||
                  schemas.forms.progessResult.comment?.enableEdit
                }
                schema={schemas.forms.progessResult}
                isEdit={isEditWidget.progessResult}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('progessResult', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* องค์กรภาคีเครือข่ายที่สนับสนุนกิจกรรม */}
          {/* {schemas?.forms?.networkAndOrganiation && (
          <>
            <NetworkAndOrganiationView
              schema={schemas.forms.networkAndOrganiation}
              showCommandButton={
                schemas.forms.networkAndOrganiation.enableEdit ||
                schemas.forms.networkAndOrganiation.comment?.enableEdit
              }
            />
            <br />
          </>
        )} */}

          {/* แหล่งเรียนรู้ */}
          {schemas?.forms?.learningCenter && (
            <>
              <LearningCenterView
                schema={schemas.forms.learningCenter}
                values={iamValues}
                showCommandButton={
                  schemas.forms.learningCenter.enableEdit ||
                  schemas.forms.learningCenter.comment?.enableEdit
                }
                isError={errorIam}
              />
              <br />
            </>
          )}

          {/* DOL-Multimedia */}
          {schemas.forms.progressAttachmentDOL && (
            <>
              <DolMultimediaWidget schema={schemas.forms.progressAttachmentDOL} />
              <br />
            </>
          )}
          {/* {dolValues && (
          <>
            <DolMultimediaWidget value={dolValues} projectCode={projectCode} isError={errorDOL} />
            <br />
          </>
        )} */}

          {/* ปัญหาอุปสรรคที่พบพร้อมแนวทางแก้ไข */}
          {schemas?.forms?.problemsAndSolution && (
            <>
              <ProblemsAndSolutionWidget
                showCommandButton={
                  schemas.forms.problemsAndSolution.enableEdit ||
                  schemas.forms.problemsAndSolution.comment?.enableEdit
                }
                schema={schemas.forms.problemsAndSolution}
                isEdit={isEditWidget.problemsAndSolution}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('problemsAndSolution', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* การประเมินความเสี่ยง */}
          {schemas?.forms?.riskAssessment && (
            <>
              <RiskAssessmentWidget
                showCommandButton={
                  schemas.forms.riskAssessment.enableEdit ||
                  schemas.forms.riskAssessment.comment?.enableEdit
                }
                schema={schemas.forms.riskAssessment}
                isEdit={isEditWidget.riskAssessment}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('riskAssessment', _isEdit, setIsEditWidget)
                }
              />
              <br />
            </>
          )}

          {/* ตรงรายงาน***การประเมินภาคี */}
          {schemas?.forms?.evaluation && (
            <>
              <CoworkerEvaluateYourselfWidget disabled={schemas?.forms?.evaluation.disabled} />
            </>
          )}

          {/* ไฟล์แนบ */}
          {schemas?.forms?.attachments && (
            <>
              <AttachFilesWidget
                showCommandButton={
                  schemas.forms.attachments.enableEdit ||
                  schemas.forms.attachments.comment?.enableEdit
                }
                schema={schemas.forms.attachments}
                isEdit={isEditWidget.attachments}
                onChangeIsEdit={(_isEdit) =>
                  handleOnChangeIsEdit('attachments', _isEdit, setIsEditWidget)
                }
                infoMessage={'แนบเอกสารประกอบเพิ่มเติม นอกเหนือจากสื่อพร้อมเผยแพร่ที่ใส่ในระบบ DOL'}
              />
              <br />
            </>
          )}

          {/* ครุภัณฑ์โครงการ */}
          {/* {schemas?.forms?.progressAsset && (
          <>
            <ProgressAssetWidget
              showCommandButton={
                schemas?.forms?.progressAsset?.enableEdit ||
                schemas.forms.progressAsset.comment?.enableEdit
              }
              schema={schemas.forms.progressAsset}
              isEdit={isEditWidget.progressAsset}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('progressAsset', _isEdit, setIsEditWidget)
              }
            />
            <br />
          </>
        )} */}

          {schemas?.forms?.sendFeedback && (
            <>
              <SendFeedbackWidget
                showCommandButton={schemas.forms.sendFeedback.enableEdit}
                schema={schemas.forms.sendFeedback}
              />
              <br />
            </>
          )}

          {isPdfError ? (
            <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
          ) : (
            <div style={{ marginTop: -30 }}>
              <PdfRenderWidgets
                header={'รายงานความก้าวหน้า'}
                file={previewPdf}
                isLoading={isLoadingPDF}
                fileName={'รายงานความก้าวหน้า'}
                onReload={() => handleGetDownloadProgressFile(projectId, progressId)}
                loadingMessage={'กรุณารอสักครู่ ระบบกำลังสร้าง PDF รายงานความก้าวหน้า...'}
                firstExpandToReload={true}
              />
            </div>
          )}
          <br />
        </div>

        <div
          style={{
            position: 'fixed',
            zIndex: 997,
            right: 10,
            bottom: 80,
            textAlign: 'right',
          }}
        >
          {schemas?.forms?.progressInfo?.withdrowId && (
            <Row style={{ marginBottom: 10 }}>
              <IconButton
                // appearance="ghost"
                className="rs-btn-info"
                style={{ marginRight: '10px' }}
                onClick={() => {
                  gotoWithdraw(schemas.forms.progressInfo.withdrowId)
                }}
                disabled={isLoading}
                icon={<Icon className="bt-gost-icon-radius-info" icon="external-link-square" />}
              >
                ไปยังส่วนขอเบิกงวดเงิน
              </IconButton>
              {/* <ViewButton
              icon="external-link-square"
              onClick={() => {
                gotoWithdraw('1C2C8A40-96FD-4180-8816-B32655C260A9')
              }}
            >
              ไปยังส่วนขอเบิกงวดเงิน{' '}
            </ViewButton> */}
            </Row>
          )}

          {schemas?.forms?.progressInfo?.isBeforeFinal && (
            <Row style={{ marginBottom: 10 }}>
              <IconButton
                appearance="ghost"
                className="rs-btn-save"
                style={{ marginRight: '10px' }}
                onClick={handleCallUpdateToClose}
                disabled={isLoading}
                icon={<Icon className="bt-gost-icon-radius" icon="tasks" />}
              >
                รายงานความก้าวหน้าพร้อมรายงานงวดปิด
              </IconButton>
            </Row>
          )}
        </div>
      </SidebarProposal>

      <ConfirmWidget
        title={'ยืนยันการ'}
        show={isShowConfirm}
        size="sm"
        detail={
          <div style={{ marginTop: 10, paddingTop: -10 }}>
            กรุณายืนยันการ{schemas?.forms?.copyPreviousProgress?.buttonText}
          </div>
        }
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleGetPreviousProgressReport}
      />
    </>
  )
}
